var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAlignRightIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 36,
  height: 34,
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h36v34H0z"
}), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "#545454"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.25 18h9.5v7.5h-9.5V18zm-8-10.5h17.5V15H9.25V7.5z",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.75 18v7.5h-9.5V18h9.5zm-1.5 1.5h-6.5V24h6.5v-4.5zm1.5-12V15H9.25V7.5h17.5zM25.25 9h-14.5v4.5h14.5V9z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.65,
  d: "M28.25 5v23h2V5z"
})))));
export default SvgAlignRightIcon;